module.exports = __webpack_public_path__ + "static/14-6a78758a64378ec4e55be8d9942ca4cb.jpg";